var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=bulk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rectangle",
    d: "M1.25 7.25C1.25 3.93629 3.93629 1.25 7.25 1.25H16.75C20.0637 1.25 22.75 3.93629 22.75 7.25V16.75C22.75 20.0637 20.0637 22.75 16.75 22.75H7.25C3.93629 22.75 1.25 20.0637 1.25 16.75V7.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2487 6.34746C15.4339 5.55085 14.1059 5.55085 13.2911 6.34746L6.7096 12.7821C5.43013 14.033 5.43013 16.054 6.7096 17.3049C7.99852 18.565 10.0951 18.565 11.3841 17.3049L18.4757 10.3715C18.7719 10.082 19.2467 10.0873 19.5363 10.3835C19.8259 10.6797 19.8205 11.1545 19.5243 11.4441L12.4327 18.3774C10.5608 20.2075 7.53282 20.2075 5.66098 18.3774C3.77967 16.5381 3.77967 13.5489 5.66098 11.7095L12.2425 5.2749C13.6402 3.90837 15.8996 3.90837 17.2973 5.2749C18.7045 6.65068 18.7045 8.88842 17.2973 10.2642L10.9895 16.4312C10.0658 17.3342 8.57523 17.3342 7.65161 16.4312C6.71854 15.519 6.71854 14.0328 7.65161 13.1205L13.4742 7.42789C13.7704 7.13832 14.2452 7.14368 14.5348 7.43986C14.8244 7.73604 14.819 8.21089 14.5228 8.50045L8.70023 14.1931C8.369 14.5169 8.369 15.0348 8.70023 15.3587C9.04092 15.6918 9.60015 15.6918 9.94084 15.3587L16.2487 9.19164C17.054 8.40427 17.054 7.13484 16.2487 6.34746Z",
    fill: "#2D42B6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.01656723fa75c54604ab4be1b1e0f346.svg";
export { ForwardRef as ReactComponent };